




import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class Home extends Vue {
  isDesktop = false;
  created() {
    // ✅ Preserve query params when redirecting
    this.$router.replace({
      name: "welcome",
      query: this.$route.query,
    });
  }
  checkDevice() {
    return !/Mobi|Android/i.test(navigator.userAgent);
  }
}
